import { toPercentageStr, roundToFixedN } from '../../../main/support/utils';
import { UNDISCLOSED_EVENT_VALUE } from '../../support/utils/eo_constants';

export const percentageFormatter = (value) => {
  if (value === UNDISCLOSED_EVENT_VALUE) {
    return UNDISCLOSED_EVENT_VALUE;
  }

  return toPercentageStr(roundToFixedN(value > 100 ? 2 : 4, Number(value)));
};
